import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "@app/auth/components/login/login.component";
import { RedirectComponent } from "@app/auth/components/redirect/redirect.component";
import { NgModule } from "@angular/core";
import { FooterOnlyLayoutComponent } from "@app/shared/components/layouts/footer_only/footer_only.component";
import { RegisterComponent } from "@app/auth/components/register/register.component";
import { VerifyComponent } from "@app/auth/components/verify/verify.component";
import { PasswordResetComponent } from "@app/auth/components/password_reset/password_reset.component";
import { EmailVerifiedComponent } from "@app/auth/components/email_verified/email_verified.component";
import { SpecialRegisterComponent } from "@app/auth/components/special_register/special_register.component";

const routes: Routes = [
  {
    component: FooterOnlyLayoutComponent,
    path: "",
    children: [
      {
        component: RedirectComponent,
        path: "redirect",
      },
      {
        component: RegisterComponent,
        path: "register",
      },
      {
        component: PasswordResetComponent,
        path: "password_reset",
      },
      {
        component: VerifyComponent,
        path: "verify/:registrationToken/:method",
      },
      {
        component: LoginComponent,
        path: "login",
      },
      {
        component: EmailVerifiedComponent,
        path: "email_verified/:recordId/:confirmationToken",
      },
      {
        path: 'register/:data_string',
        component: SpecialRegisterComponent
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutes {}
